import React from 'react';
import PropTypes from 'prop-types';
import { Switch, withRouter } from 'react-router-dom';
import { ProtectedRoute } from '../helpers/ProtectedRoute';
import LegacyRouteRedirect from '../helpers/LegacyRouteRedirect';
import Visitors from '../components/visitors/Visitors';
import CreateVisitor from '../components/visitors/CreateVisitor';
import VisitorsHistory from '../components/visitors/History';
import DetailsVisitors from '../components/visitors/DetailsVisitors';

const VisitorsRoutes = ({ match: { url } }) =>
    <Switch>
        <ProtectedRoute exact path={`${url}`} rols={['property', 'safety', 'manager']} component={Visitors} />
        <ProtectedRoute exact path={`${url}/:id(\\d+)`} rols={['property', 'safety', 'manager']} component={DetailsVisitors} />
        <ProtectedRoute exact path={`${url}/create`} rols={['property']} component={CreateVisitor} />
        <ProtectedRoute exact path={`${url}/history`} rols={['safety', 'property']} component={VisitorsHistory} />
        <LegacyRouteRedirect />
    </Switch>

VisitorsRoutes.propTypes = { match: PropTypes.object.isRequired };

export default withRouter(VisitorsRoutes);